module.exports = function (Vue) {
  Vue.filter("nrOfDays", (value) => {
    // if(!value) return '';
    const entry = new Date(value.TimeEnter);
    const exit = new Date(value.TimeExit);
    const diff = exit - entry;

    const msPerDay = 24 * 60 * 60 * 1000; // Number of milliseconds per day
    const daysLeft = diff / msPerDay;
    if (daysLeft < 1) {
      return "< 1 D";
    }
    return daysLeft.toFixed(0).toString() + " D";
  }),
    Vue.filter("openTradePossibleWaiting", (value) => {
      if (isNaN(value)) return "";
      const posValue = Math.abs(value);
      let returnValue = "";
      if (posValue === 0) {
        return "Pending next trade.";
      } else if (posValue > 0 && posValue < 1) {
        returnValue = value.toFixed(5);
      } else if (posValue < 10) {
        returnValue = value.toFixed(5);
      } else if (posValue < 100) {
        returnValue = value.toFixed(3);
      } else if (posValue < 1000) {
        returnValue = value.toFixed(2);
      } else {
        returnValue = value
          .toFixed(0)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return returnValue + " Ƀ";
    }),
    Vue.filter("cryptoFormat", (value) => {
      if (isNaN(value)) return "";
      const posValue = Math.abs(value);
      if (posValue > 0 && posValue < 1) {
        return (+value.toFixed(5)).toString();
      }
      if (posValue < 10) {
        return (+value.toFixed(5)).toString();
      }
      if (posValue < 100) {
        return (+value.toFixed(3)).toString();
      }
      if (posValue < 1000) {
        return (+value.toFixed(2)).toString();
      }
      return value
        .toFixed(0)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }),
    Vue.filter("btcFormat", (value) => {
      function truncate(numToTruncate, numDecimals) {
        let theNum = numToTruncate.toString();
        let pointIndex = theNum.indexOf(".");
        return +theNum.slice(
          0,
          pointIndex > -1 ? ++numDecimals + pointIndex : undefined
        );
      }

      if (isNaN(+value)) return "";
      if (value === 0) return `0 Ƀ`;
      const posValue = Math.abs(value);
      if (posValue < 0.00001) {
        let satoshis = Math.round(value / 0.00000001);
        if (satoshis < 1) {
          return 0;
        }
        return `${satoshis} satoshi`;
      } else {
        let btc;
        if (posValue > 0 && posValue < 1) {
          btc = truncate(value, 5);
        } else if (posValue < 10) {
          btc = truncate(value, 5);
        } else if (posValue < 100) {
          btc = truncate(value, 3);
        } else if (posValue) {
          btc = truncate(value, 2);
        } else {
          return "";
        }
        return `${btc} Ƀ`;
      }
    }),
    Vue.filter("satoshiFormat", (value) => {
      if (isNaN(value)) return "";
      const posValue = Math.abs(value);
      if (posValue < 0.00001) {
        let satoshis = Math.round(value / 0.00000001);
        if (satoshis < 1) {
          return 0;
        }
        return satoshis;
      }
      return "";
    }),
    Vue.filter("largeNumber", (value) => {
      const num = +value;
      if (Number.isNaN(num)) return value;
      if (num > 1000000000) {
        return (num / 1000000000).toFixed(3) + "B";
      } else if (num > 1000000) {
        return (num / 1000000).toFixed(3) + "M";
      } else
        return num
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }),
    Vue.filter("fiatFormat", (value) => {
      if (isNaN(value)) return "";
      if (value >= 0.01) {
        return value
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      if (value >= 0.001) {
        return value.toFixed(3);
      }
      if (value >= 0.0001) {
        return value.toFixed(4);
      }
      if (value >= 0.00001) {
        return value.toFixed(5);
      }
      if (value >= 0.000001) {
        return value.toFixed(6);
      }
      return value.toFixed(2);
    }),
    Vue.filter("pctFormat", (number) => {
      if (number === null || number === "" || isNaN(number)) {
        return "0.00%";
      }
      return Math.round(number * Math.pow(10, 2) * 100) / Math.pow(10, 2) + "%";
    }),
    Vue.filter("dateFormatShort", (value, locale = "en-US") => {
      if (!value) return "";
      const dateValue = new Date(value);
      return dateValue.toLocaleDateString(locale);
    }),
    Vue.filter("dateFormatLong", (value, locale = "en-US") => {
      if (!value) return "";
      const dateValue = new Date(value);
      return (
        dateValue.toLocaleDateString(locale) +
        " " +
        dateValue.toLocaleTimeString(locale)
      );
    });
};
